import React from 'react';
import Moment from 'react-moment';
import { useHistory } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { SlashIcon } from 'lucide-react';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const ComplexServiceDetails = () => {
  const history = useHistory();
  const research = history.location.state?.data;

  return (
    <div className="space-y-5">
      <Breadcrumb className="px-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/userAccount/complex-services">Kompleksinės paslaugos</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <SlashIcon />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbPage>{research.serviceName}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      {/* Card 1: General Info */}
      <Card>
        <CardHeader>
          <Heading variant="userAccountDetailsTitle">Paketo informacija</Heading>
        </CardHeader>
        <CardContent className="space-y-2">
          <div>
            <span>Data: </span>
            <span>
              {new Date(Date.parse(research.date)).getUTCHours() === 0 ? (
                <Moment utc format="YYYY-MM-DD">{research.date}</Moment>
              ) : (
                <Moment utc format="YYYY-MM-DD HH:mm">{research.date}</Moment>
              )}
            </span>
          </div>

          <div>
            <span>Pavadinimas: </span>
            <span>{research.serviceName}</span>
          </div>

          {research.sum && (
            <div>
              <span>Kaina: </span>
              <span>{research.sum}€</span>
            </div>
          )}

          {research.status && (
            <div>
              <span>Būsena: </span>
              <span>{research.validityStatus}</span>
            </div>
          )}
        </CardContent>
        <CardFooter />
      </Card>

      {/* Card 2: Services Table */}
      <Card>
        <CardHeader>
          <Heading variant="userAccountDetailsTitle">Paketui priklausančios paslaugos</Heading>
        </CardHeader>
        <CardContent className="space-y-4">
          {research.serviceParts?.length > 0 ? (
            research.serviceParts.map((part, index) => (
              <Card
                key={index}
                className="bg-muted ml-4 border-none shadow-none max-w-3xl"
              >
                <CardContent className="space-y-2 py-4">
                  <div>
                    <span>Pavadinimas: </span>
                    <span>{part.name}</span>
                  </div>

                  {part.objectServices?.length > 0 && (
                    <div>
                      <span>Dedamosios dalys: </span>
                      <span>
                        {part.objectServices
                          .map((service) =>
                            service.name
                              .replace(' | AFF / MP', '')
                              .replace(' | AFF', '')
                              .replace(' | MP', '')
                          )
                          .join(', ')}
                      </span>
                    </div>
                  )}

                  <div>
                    <span>Kiekis: </span>
                    <span>{part.quantity}</span>
                  </div>

                  <div>
                    <span>Nepanaudotas kiekis: </span>
                    <span>{part.unusedQuantity}</span>
                  </div>
                </CardContent>
              </Card>
            ))
          ) : (
            <div className="text-muted-foreground">Nėra paslaugų šiame pakete.</div>
          )}
        </CardContent>
        <CardFooter />
      </Card>
    </div>
  );
};

export default ComplexServiceDetails;
